const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  //   textFieldL: {
  //     marginRight: theme.spacing.unit * 2,
  //     width: 320
  //   },
  //   textFieldR: {
  //     marginRight: theme.spacing.unit * 2,
  //     width: 580
  //   },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between"
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  mainBody: {
    maxWidth: 650,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto"
  },
  checkBox: {
    display: "block"
  },
  lookup: {
    fontSize: "1.2em",
    fontWeight: "bold"
  },
  textFieldTime: {
    marginRight: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 35
  },
  radiogrp: {
    right: 430,
    display: "flex"
  },
  restoreButton: {
    padding: "0 !important"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/subtestsetting/uptime/styles.js